import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  FormHelperText,
} from "@mui/material";
import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import StepperGuide from "src/components/StepperGuide";
import RenderTimeSlots from "src/views/general/booking-components/RenderTimeSlots";

const DateAndTimezone = ({
  errors,
  selectedTimezone,
  sessionList,
  selectedSessionTime,
  setSessionSelectedTime,
  selectedOffer,
  appForThisOffer,
  blockTimeOnSelectedDate,
  selectedDate,
  setError,
  nextButtonRef,
  userDateFormat,
  userTimeFormat,
  userMinimumBookingNotice,
  stepperGuideLength,
  allUpcommingAppt,
  overFlowTimeToRender,
  underFlowTimeToRender,
  preparingSessionList,
  coachDetails,
}) => {
  const { t } = useTranslation();

  const [timeHover, setTimeHover] = React.useState(null);

  const handleSelectedTime = async (time) => {
    let error = [];
    let minimumBookingNotice = parseInt(userMinimumBookingNotice);
    let coachDateTimeFormat = `${userDateFormat} ${userTimeFormat}`;
    let timeNow = moment(new Date());
    let minimumBooking = moment(
      new Date(time.start),
      coachDateTimeFormat
    ).subtract(minimumBookingNotice, "hours");

    if (minimumBookingNotice > 0) {
      if (timeNow.isAfter(minimumBooking)) {
        setError("time", {
          message: t("booking.error.required.minimum_booking", {
            minimumBookingNotice,
          }),
          required: true,
        });
        error = "error-selected-time-is-not-available";
      }
    }

    if (error.length > 0) {
      console.log("error:", error);
      return;
    }

    await setSessionSelectedTime({
      start: time.start,
      end: time.end,
    });

    nextButtonRef?.current?.click();
  };

  const filteredList = sessionList ?? [];

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            pt: "58px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "var(--font-grenettepromedium)",
                fontSize: "18px",
                lineHeight: "31px",
                alignItems: "center",
                color: "#060A2D",
              }}
            >
              {t("individual.booking.schedule.choose_schedule")}
            </Typography>

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "18px",
                color: "#878787",
                mt: "4px",
              }}
            >
              {t("individual.booking.schedule.choose_schedule.description", {
                package: selectedOffer?.name,
              })}
            </Typography>
          </Box>

          <Box>
            <StepperGuide length={stepperGuideLength} activeLength={[1, 2]} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: "48px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: "10px", md: "32px" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* availabitlity */}
          <Box
            style={{
              width: "100%",
            }}
          >
            <Box>
              <Box mb={"10px"}>
                <Typography
                  sx={{
                    fontFamily: "var(--font-grenettepromedium)",
                    fontSize: "10px",
                    lineHeight: "11px",
                    letterSpacing: "0.07em",
                    color: "#A1A1A1",
                    textTransform: "uppercase",
                  }}
                >
                  {t("booking.placeholder.time_slots")}
                </Typography>

                {Boolean(errors?.time) && (
                  <FormHelperText error>
                    {" "}
                    {errors?.time?.message}{" "}
                  </FormHelperText>
                )}
              </Box>

              {selectedDate === null ? (
                <NoAvailableTime
                  message={t("booking.error.required.select_date")}
                />
              ) : (
                <Box className="session-time-scroll">
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {preparingSessionList ? (
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          mt: "10px",
                        }}
                      >
                        <CircularProgress size={20} />
                      </Box>
                    ) : filteredList?.length > 0 ? (
                      <Grid container spacing={"10px"}>
                        {filteredList?.map((time, key) => {
                          return (
                            <Grid item xs={6} sm={6} key={key}>
                              <Box key={key}>
                                <RenderTimeSlots
                                  selectedSessionTime={selectedSessionTime}
                                  time={time}
                                  handleSelectedTime={handleSelectedTime}
                                  timeHover={timeHover}
                                  setTimeHover={setTimeHover}
                                  userTimeFormat={userTimeFormat}
                                  _key={key}
                                />
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    ) : (
                      <NoAvailableTime
                        message={t(
                          "booking.error.required.no_time_on_selected_date"
                        )}
                      />
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DateAndTimezone;

const NoAvailableTime = ({ message }) => (
  <Box
    sx={{
      height: "338px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#F2F2F2",
      width: "100%",
      borderRadius: "8px",
    }}
  >
    <Typography
      sx={{
        fontFamily: "var(--font-grenettepromedium)",
        fontSize: "10px",
        lineHeight: "11px",
        letterSpacing: "0.07em",
        color: "#A1A1A1",
        textTransform: "uppercase",
      }}
    >
      {message}
    </Typography>
  </Box>
);
